<template>
	<div>
		<template v-if="Object.keys(selectedStudent).length > 0">
			<template v-if="roleRules.GRADES_FLG === 'Y'">
				<section v-for="( school, schoolIdx ) in courseList" :key="`school-${schoolIdx}`">
					<div class="row">
						<div class="col-xs-12">
							<h2>
								{{ school.SCHOOL_TITLE }}
							</h2>
						</div>
						<div class="col-xs-12 col-sm-6 col-lg-4">
							<sapphire-toggle
								v-model="showNonGrade"
								:label="$t('MAIN_CONTENT.CoursesAndGradesList.showNonHyphenGradeClasses')"
								:ariaLabel="$t('MAIN_CONTENT.CoursesAndGradesList.showNonHyphenGradeClasses')"
								style="margin-top: 12px;"
							>
							</sapphire-toggle>
						</div>
					</div>
					<div class="table-responsive">
						<table-editable-list :columns="columns"
																	:showColumns="showHideColumns"
																	:show-select="false"
																	:show-actions="false">
							<template slot="data-row">
								<template v-for="(course, courseIdx) in school.COURSES">
									<table-list-row :key="`course-${ course.COURSE_ID }-${courseIdx}`"
																	:columns="columns"
																	:showColumns="showHideColumns"
																	:rowdata="course"
																	:rowIndex="courseIdx"
																	:useAnchor="false"
																	:showActions="false"
																	v-if="!!course.COURSE_SECTION_GUID">
									</table-list-row>
								</template>
							</template>
						</table-editable-list>
					</div>
				</section>
			</template>
			<template v-else>
				{{ $t('MAIN_CONTENT.commonContent.invalidPermissions') }}
			</template>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
		</template>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import Courses from '../../api/Courses';

	import SapphireToggle from 'COMMONS/SapphireToggle/SapphireToggle.vue';
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		data() {
			return {
				isLoading : {
					settings : false
				},
				selectedColumns: [],
				showHideColumns: [],
				showNonGrade: false,
				schoolTitle: 'Placeholder',
				sortOrders : {},
				courses: [],
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules']),
			courseList() {
				let list = [];
				let listIndex = -1;

				let currentDate = moment();

				for(let i in this.courses) {
					let course = this.courses[i];

					let isActive = (course.ADD_DROP_FLG === 'D' && currentDate.isBefore(course.DROP_DATE)) || (course.ADD_DROP_FLG === 'A' && currentDate.isSameOrAfter(course.ADD_DATE));

					if((+i === 0 || course.SCHOOL_ID !== this.courses[+i - 1].SCHOOL_ID)) {
						list.push({SCHOOL_ID: course.SCHOOL_ID, SCHOOL_TITLE: course.SCHOOL_TITLE, COURSES: []});
						listIndex++;
					}
					course.TIME_PATTERN = course.TIMEPATTERN.replace(/&nbsp;/g, ' ').trim();
					course.LINK = course.GRADES_FLG === 'Y' ?  `/class-pages/${course.COURSE_SECTION_GUID}`:'';

					if((course.GRADES_FLG === 'Y' || this.showNonGrade) && isActive) {
						list[listIndex].COURSES.push(course);
					}
				}

				return list;
			},
			columns() {
				return [
					{
						heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.courseTitle'),
						key: 'COURSE_TITLE',
						customCol: 'title',
						type: 'link',
						link: 'LINK'
					},
					{
						heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.teacher'),
						key: 'TEACHER_NAME',
						customCol: 'teacher'
					},
					{
						heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.periodDays'),
						key: 'TIME_PATTERN',
						customCol: 'period-days',
						type:'html'
					},
					{
						heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.room'),
						key: 'ROOM_CODE',
						customCol: 'room'
					},
					{
						heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.duration'),
						key: 'DURATION_CODE',
						customCol: 'duration'
					},
					{
						heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.currentGrade'),
						key: 'CURRENT_GRADE',
						customCol: 'grade'
					}
				];
			}
		},
		components: {
			SapphireToggle,
			TableEditableList,
			TableListRow
		},
		methods: {
			loadStudentCourses() {
				const self = this;

				let courses = new Courses({
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						sort_columns: "STATUS_FLG,SCHOOL_TITLE,PERIOD_ORDER,DURATION_CODE,COURSE_ID,SECTION_ID,ADD_DATE,DROP_DATE,SEAT_TAKEN,COURSE_TITLE,STAFF_NAME,ROOM_DESC,DROPPED_WITH_GRADE_FLG",
						sort_direction: "ASC",
					}
				});
				const promise = courses.get();

				promise.then(response => {
					self.$set(self, 'courses', response.data.data);
				})
				.catch(error => {
					console.log(error);
				});
			},
			adjustTable() {
				let mainTableWidth =
				document.getElementsByTagName("body")[0].getBoundingClientRect()
					.width;
				if(mainTableWidth < 500){
					this.showHideColumns = [
						{
							heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.courseTitle'),
							key: 'COURSE_TITLE',
							customCol: 'title',
							type: 'link',
							link: 'LINK'
						},
						{
							heading: this.$t('MAIN_CONTENT.CoursesAndGradesList.currentGrade'),
							key: 'CURRENT_GRADE',
							customCol: 'grade'
						}
					];
				}
				else{
					this.showHideColumns = [];
				}
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'book');
			this.$store.commit('setTitle', 'MAIN_CONTENT.CoursesAndGradesList.sideMenuCoursesAndGradesLink');
			this.$store.commit('setUseHeader', true);

			if(this.roleRules.GRADES_FLG === 'Y') {
				this.loadStudentCourses();
			}
			this.adjustTable();
		},
		mounted(){
			window.addEventListener("resize", this.adjustTable);
		},
		destroyed(){
			window.removeEventListener("resize", this.adjustTable);
		}
	}
</script>
